import serviceTableMaintenance from './service-table-maintenance.js';
import './service-table-maintenance.scss';

export default serviceTableMaintenance;
